'use client'

import { getAxiosApiClientByUser } from './axiosInstance'

interface CreditLogsParams {
  page?: number // minimum 1
  limit?: number // minimum 1, maximum 100
  user_name?: string
  feature?: string
  date?: string // in 'YYYY-MM-DD' format
  date_to?: string // in 'YYYY-MM-DD' format
  credits?: string // amount of credits filter
}

export const getCreditsSummary = async () => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.get('/credit/summary')
    return response.data
  } catch (error) {
    console.error('Error fetching credits summary:', error)
    return null
  }
}

export const getCreditsLogs = async (params: CreditLogsParams = {}) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.get('/credit/usage-logs', {
      params: {
        ...params,
        page: params.page && params.page >= 1 ? params.page : 1,
        limit:
          params.limit && params.limit >= 1 && params.limit <= 100
            ? params.limit
            : 10
      }
    })
    return response.data
  } catch (error) {
    console.error('Error fetching credits logs:', error)
    return null
  }
}

export interface CreditSettings {
  autoRechargeEnabled: boolean
  rechargeThreshold: number
  rechargeAmount: number
  monthlySpendCap: number
  allowExcessCharges: boolean
  emailNotificationsEnabled: boolean
}

export const getCreditSettings = async () => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.get('/credit-settings')
    return response.data
  } catch (error) {
    console.error('Error fetching credit settings:', error)
    return null
  }
}

export const updateCreditSettings = async (settings: CreditSettings) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.put('/credit-settings', settings)
    return response.data
  } catch (error) {
    console.error('Error updating credit settings:', error)
    throw error
  }
}
